const demo_app = {
    notification: 'Совет: Создайте аккаунт сначала, чтобы протестировать процесс входа.',
};
export default Object.freeze(demo_app);
